import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { MenuComponent } from './menu/menu.component';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ItemComponent } from './item/item.component';
import { NewAdressComponent } from './new-adress/new-adress.component';
import { FloatCartComponent } from './float-cart/float-cart.component';
import { PaymentsComponent } from './payments/payments.component';

@NgModule({
  declarations: [
    MenuComponent,
    ItemComponent,
    NewAdressComponent,
    FloatCartComponent,
    PaymentsComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
  ],
  exports: [
    MenuComponent,
    ItemComponent,
    NewAdressComponent,
    FloatCartComponent
  ]
})

export class ComponentsModule { }